module.exports = __webpack_public_path__ + "img/home_bg_03_3.21cf5f58.png";